export function isPaywallModalExemptPath(pathname: string): boolean {
  return pathname === "/matches" || pathname.startsWith("/chat/") || pathname.startsWith("/profile");
}

export function shouldShowEventAccessPaywallModal(params: {
  requiresPaymentWall: boolean;
  forcedOpen: boolean;
  pathname: string;
}): boolean {
  if (isPaywallModalExemptPath(params.pathname)) {
    return false;
  }
  return params.requiresPaymentWall || params.forcedOpen;
}

export function shouldShowVipLikedYouPaywallModal(pathname: string): boolean {
  return pathname === "/liked-you";
}
